import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  currentThemeMode,
  DEFAULT_THEME,
  isThemeMode,
  setThemeMode,
  THEME_MODES,
} from '../theme-mode.ts';

/**
 * Chiaro o scuro.
 *
 * Sta accanto alla lingua perché è la stessa specie di scelta — riguarda chi
 * guarda, non l'ente — e perché da lì si raggiunge da qualunque schermata: chi
 * si ritrova la console scura la vuole chiara subito, non dopo aver cercato in
 * quale sezione si cambia.
 *
 * Una `<select>` con una `<label>` vera, come `LocalePicker`: un interruttore
 * disegnato a mano sarebbe da rendere accessibile daccapo, e lo stato sarebbe
 * affidato al solo aspetto invece che a una parola (sezione 7bis).
 */
export function ThemePicker() {
  const { t } = useTranslation();
  // Cosa si **vede**, non cosa è stato salvato: nella galleria le due cose
  // possono differire, e un selettore che dichiara il contrario dello schermo
  // è peggio di nessun selettore.
  const [mode, setMode] = useState(currentThemeMode);

  return (
    <div className="field field--inline">
      <label htmlFor="theme">{t('theme.label')}</label>
      <select
        id="theme"
        value={mode}
        onChange={(event) => {
          // Cosa sia una palette lo sa `theme-mode.ts`, in un punto solo.
          const next = isThemeMode(event.target.value) ? event.target.value : DEFAULT_THEME;
          setThemeMode(next);
          setMode(next);
        }}
      >
        {THEME_MODES.map((value) => (
          <option key={value} value={value}>
            {t(`theme.${value}`)}
          </option>
        ))}
      </select>
    </div>
  );
}
